<ng-container *transloco="let t; read: 'requested-slot-select'">
  <p-radioButton
    [ariaLabel]="t('primary')"
    [disabled]="!requestableSlots.primary"
    [label]="t('primary')"
    [name]="rowData.id"
    [value]="assignedUserType.primary"
    [(ngModel)]="selectedSlot"
    (ngModelChange)="reflectSlotChange($event)"
  ></p-radioButton>
  <p-radioButton
    [ariaLabel]="t('backup')"
    [disabled]="!requestableSlots.backup"
    [label]="t('backup')"
    [name]="rowData.id"
    [value]="assignedUserType.backup"
    [(ngModel)]="selectedSlot"
    (ngModelChange)="reflectSlotChange($event)"
  ></p-radioButton>
</ng-container>
